export const venuesWithExcludedHostLiquor = [
  'AK',
  'AL',
  'DC',
  'IA',
  'OR',
  'VT',
];
